import abl from './js/abl';
import Router from './js/router';
import './css/abl.css';

abl.setRouter(new Router());


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/